import LayerGroup from "ol/layer/Group";
import OlMap from 'ol/Map';
import BaseLayer from "ol/layer/Base";
import { ILayerWrapperOptions, LayerWrapper } from "../LayerWrapper";
import { Model } from "../models/model";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";


export class StructureLayer extends LayerWrapper<Model>  {

    group: LayerGroup;
    hitDetectionLayer: VectorLayer<VectorSource>;


    constructor(opts: ILayerWrapperOptions<Model>) {
        super(opts);
        this.group = new LayerGroup();

        this.hitDetectionLayer = new VectorLayer({
            source: new VectorSource(),
            zIndex: 9
        });
        this.hitDetectionLayer.set('id', 'structure-hit-detection');

        this.addLayer(this.hitDetectionLayer);
    }


    addToMap(map: OlMap, zIndex = 10): this {
        try {
            map.addLayer(this.group);
            this.group.setZIndex(zIndex);
            this.map = map;
        }
        catch(e) {
            console.warn('Failed to add StructureLayer to map. Cause:', e);
        }

        return this;
    }


    addHitDetectionFeature(feature: Feature) {
        this.hitDetectionLayer.getSource().addFeature(feature);
    }

    removeHitDetectionFeature(feature: Feature) {
        this.hitDetectionLayer.getSource().removeFeature(feature);
    }

    addLayer(layer: BaseLayer) {
        this.group.getLayers().push(layer);
    }

    removeLayer(layer: BaseLayer) {
        this.group.getLayers().remove(layer);
        layer.dispose();
    }


}
